/**
 * 
 * @param {object} schema schema for table to base the new row on
 * @param {function} setData setter function from parent component so we can add the new empty row
 * @param {number} insertIndex if included, add the row at this index
 */
export const handleAddRow = (schema, setData, insertIndex = null, newRowData) => {
    
    let newRow = {}

    Object.keys(schema).forEach(key => {
        newRow[key] = ""
    })

    //replace empty fields with the data that the user entered
    if(newRowData){
        newRow = {
            ...newRow,
            ...newRowData
        }
    }
    
    setData(prevData => {
        const newData = [...prevData]

        if(insertIndex !== undefined && insertIndex !== null){
            newData.splice(insertIndex, 0, newRow)

        } else {
            newData.push(newRow)
        }
        
        return newData;
      });

}